import { clear } from '../../../../helpers/compact';
import { PostmenSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const postmenTitleSlice = ({ primary }) =>
  clear({
    type: PostmenSliceType.POSTMEN_TITLE,
    value: toTextFromProp('postmenTitle', primary),
  });
